<template>
  <d2-container class="test">
    <!-- 表格头部搜索 -->
    <template slot="header">
      <div style="width: 73%; display: flex; float: left; height: 48px">
        <span align="right" style="
            align: right;
            display: inline-block;
            width: 100px;
            line-height: 48px;
          ">关键字</span>
        <div style="padding: 8px 0px; width: 80%">
          <el-input clearable @keyup.enter.native="search()" style="margin-left: 10px; height: 48px" class="filter-item"
            placeholder="案号，当事人" v-model="CaseInfo.keyWord" size="small">
          </el-input>
        </div>

      </div>
      <div style="display: flex; justify-content: center;
  align-items: center;margin-top:10px">
        <div style="text-align: center">
          <el-button style="width: 5rem" class="filter-item" type="primary" round icon="search" @click.stop="search()"
            size="small">搜索</el-button>
          <el-button style="width: 5rem" class="filter-item" type="danger" round icon="search" @click.stop="resetTemp()"
            size="small">重置</el-button>

        </div>
      </div>
      <!-- <el-collapse class="test" ref="coll">
        <el-collapse-item name="1">
          <template slot="title">
            
          </template>
</el-collapse-item>
</el-collapse> -->
      <div style="display: flex"></div>
    </template>


    <!-- 批量备注 -->
    <el-dialog title="批量备注" :visible.sync="showNotes" width="30%" center :close-on-click-modal="false">
      <el-input type="textarea" :rows="12" placeholder="请输入内容" v-model="remark">
      </el-input>
      <div style="display: flex" class="notesBtn">
        <div>
          <el-button style="" type="primary" @click="batchRemark">确定</el-button>
        </div>
        <div>
          <el-button style="margin-left: 10px" type="" @click="showNotes = false">取消</el-button>
        </div>
      </div>
    </el-dialog>


    <!-- 新增案件 -->
    <el-button style="margin-left: 50px" class="filter-item" type="primary" icon="search" @click="showCreateCase"
      v-permission:function="['liveCase_add']" size="small">创建案件</el-button>


    <el-button @click="showNotes = true" style="margin-left: 50px" class="filter-item" type="primary" icon="search"
      size="small">批量备注</el-button>

    <span style="margin-left: 20px"> 表格高度： </span>
    <el-input style="width: 10%" type="number" v-model="tableHeight" @input="setTableHeight"
      placeholder="数字"></el-input>
    <!-- 案件列表 -->
    <el-table v-loading.body="listLoading" border type="index" :data="list" size="small" stripe :height="tableHeight"
      row-key highlight-current-row @selection-change="handleSelectionChange"
      style="width: 100vw; margin-top: 4px; overflow: auto">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column width="80" align="center" label="系统编号">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="案号">
        <template slot-scope="scope">
          <span>{{ scope.row.registerCode }}</span>
        </template>
      </el-table-column>

      <el-table-column width="250" align="center" label="当事人">
        <template slot-scope="scope">
          <div>{{ scope.row.plaintiffName }}</div>
          <el-link type="primary" @click="showEditPage(scope.$index, scope.row)">{{ scope.row.defendantName }}</el-link>
        </template>
      </el-table-column>

      <el-table-column width="120" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.caseStatus == '未处置'" type="info">{{
              scope.row.caseStatus
            }}</el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '处置中'" type="warning">{{
              scope.row.caseStatus
            }}</el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '已立案待缴费'" type="danger">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '已缴费待排期'" type="danger">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '案件异动'" type="danger">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '待开庭'" type="danger">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '已开庭待判决'" type="danger">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '已判决'" type="success">{{ scope.row.caseStatus }}
          </el-tag>

          <el-tag v-else type="danger">{{ scope.row.caseStatus }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column width="100" align="center" label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="提交法院日期">
        <template slot-scope="scope">
          <div> {{ scope.row.courtSubDate }}</div>
        </template>
      </el-table-column>

      <el-table-column width="150" align="center" label="立案日期">
        <template slot-scope="scope">
          <span> {{ scope.row.filingDate }}</span>
        </template>
      </el-table-column>

      <el-table-column width="150" align="center" label="开庭日期">
        <template slot-scope="scope">
          <span> {{ scope.row.trialDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="审判法官">
        <template slot-scope="scope">
          <span> {{ scope.row.undertakeJudge }}</span>
        </template>
      </el-table-column>






      <el-table-column fixed="right" align="center" label="操作" width="110">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.show == true && scope.row.username !== undefined" class="item" effect="dark"
            :content="scope.row.username" placement="top-start">
            <el-dropdown @command="handleCommand">
              <el-button type="primary">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </el-dropdown>
          </el-tooltip>

          <el-dropdown @command="handleCommand" @click.native="
              getObj(scope.row.caseStatus, scope.row.id, scope.$index)
              " v-else>
            <el-button type="danger">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-permission:function="['liveCase_edit']" v-show="isShowList[scope.$index] || isAdmin"
                :command="showDialog(scope.$index, scope.row, 'edit')">编辑</el-dropdown-item>

              <el-dropdown-item v-permission:function="['liveCase_startDisposal']"
                v-show="scope.row.caseStatus === '未处置'"
                :command="showDialog(scope.$index, scope.row, 'startDisposal')">开始处置</el-dropdown-item>

              <!-- v-show="scope.row.caseStatus === '未处置'" -->
              <!--  -->
              <el-dropdown-item v-permission:function="['liveCase_uploadCaseFile']"
                :command="showDialog(scope.$index, scope.row, 'upload')">上传案件档案</el-dropdown-item>
              <el-dropdown-item v-show="scope.row.caseStatus === '处置中' || scope.row.caseStatus === '未处置'"
                v-permission:function="['liveCase_delete']"
                :command="showDialog(scope.$index, scope.row, 'delete')">删除</el-dropdown-item>

              <el-dropdown-item v-show="scope.row.caseStatus === '处置中'" v-permission:function="['liveCase_submitJudge']"
                :command="showDialog(scope.$index, scope.row, 'submitJudge')">提交法院</el-dropdown-item>
              <el-dropdown-item v-show="scope.row.caseStatus === '提交法院'" v-permission:function="['liveCase_registered']"
                :command="showDialog(scope.$index, scope.row, 'registered')">已立案</el-dropdown-item>
              <el-dropdown-item v-show="scope.row.caseStatus === '已立案待缴费'" v-permission:function="['liveCase_pay']"
                :command="showDialog(scope.$index, scope.row, 'pay')">已缴费</el-dropdown-item>
              <el-dropdown-item v-show="scope.row.caseStatus === '已缴费待排期'" v-permission:function="['liveCase_abnormal']"
                :command="showDialog(scope.$index, scope.row, 'caseAbnormal')">案件异动</el-dropdown-item>


              <el-dropdown-item v-show="scope.row.caseStatus === '已缴费待排期' || scope.row.caseStatus === '案件异动'"
                v-permission:function="['liveCase_scheduling']"
                :command="showDialog(scope.$index, scope.row, 'scheduling')">已排期</el-dropdown-item>
              <el-dropdown-item v-show="scope.row.caseStatus === '待开庭'" v-permission:function="['liveCase_judgement']"
                :command="showDialog(scope.$index, scope.row, 'judgement')">已开庭</el-dropdown-item>

              <el-dropdown-item v-show="scope.row.caseStatus === '待开庭'"
                v-permission:function="['liveCase_reScheduling']"
                :command="showDialog(scope.$index, scope.row, 'reScheduling')">重新排期</el-dropdown-item>

              <el-dropdown-item v-show="scope.row.caseStatus === '已开庭待判决'"
                v-permission:function="['liveCase_judgementEnd']"
                :command="showDialog(scope.$index, scope.row, 'judgementEnd')">已判决</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 上传案件档案 -->
    <el-dialog title="上传案件档案" :visible.sync="caseUploadShow" width="30%" center :close-on-click-modal="false">
      <div style="width: 10rem; margin: 0px auto">
        <el-form :model="caseUploadData">
          <el-form-item label="档案资料">
            <el-upload style="width: 18rem" ref="caseUpload" class="upload-demo" :on-change="fileChange"
              :action="getCaseUploadUrl()" :http-request="mutUploadFile1" multiple :auto-upload="false"
              :file-list="fileList" :limit="100">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-button @click="caseUploadShow = false">取 消</el-button>
          <el-button v-permission:function="['liveCase_uploadCaseFile_determine']" type="primary"
            @click="addCaseFile()">确定</el-button>
        </el-form>
      </div>
    </el-dialog>


    <!-- 编辑案件 -->
    <div class="editCase">
      <el-dialog title="编辑案件" :visible.sync="testVis" width="70%" custom-class="heightFull" center @close="closeDia"
        :close-on-click-modal="false">
        <Register @getCaseStatus="getCaseStatus" :id="id" v-if="testVis"></Register>
      </el-dialog>
    </div>
    <!-- 预览案件 -->
    <el-dialog title="预览案件" custom-class="heightFull" :visible.sync="isPreview" width="70%" center
      :close-on-click-modal="false">
      <el-tabs type="border-card" v-model="tabIndex">
        <el-tab-pane label="案件信息" name="caseInfo">
          <Preview :id="id" :data="previewData" v-if="isPreview"></Preview>
        </el-tab-pane>



        <el-tab-pane label="档案资料" v-if="caseFileShow">
          <el-card class="box-card" v-for="item in caseFile" :key="item.id">
            <div slot="header" class="clearfix">
              <span>{{ item.fileName }}</span>
              <el-button v-permission:function="['liveCase_downLoadCaseFile']" @click="downCaseUploadFile(item.id)"
                style="float: right; padding: 3px 0" type="text">下载</el-button>
              <el-button v-permission:function="['liveCase_deleteCaseFile']" @click="deleteCaseUploadFile(item.id)"
                style="float: right; padding: 3px 10px" type="text">删除</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 分页 -->
    <template slot="footer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="CaseInfo.page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000]"
        :page-size="CaseInfo.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>

    <!-- 新增案件 -->
    <el-dialog :visible.sync="centerDialogVisible" title="新增案件" width="40%" center :close-on-click-modal="false">
      <el-form :model="CaseForm" :rules="rules" ref="CaseForm" label-width="100px" class="demo-CaseForm">
        <div class="center">
          <el-upload :action="getIdCardUploadUrl()" multiple :http-request="ocrUploadFile" :on-change="ocrFileChange"
            :file-list="idCardFileList">
            <el-button size="small" type="primary"
              v-permission:function="['liveCase_identifyIdCard']">识别身份证信息</el-button>

            <!-- v-permission:function="['ocr_card']" @click="getIndex(index)" -->
          </el-upload>

        </div>
        <div style="font-size:12px;margin-bottom:20px" class="center">
          温馨提示：可上传身份证照片进行快速文字识别
        </div>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="CaseForm.name" style="width: 85%"></el-input>
        </el-form-item>





        <el-form-item label="身份证" prop="idCard">
          <el-input @input="getBirthdayAndSex(CaseForm.idCard)" v-model="CaseForm.idCard" style="width: 85%"></el-input>
        </el-form-item>

        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker placeholder="选择时间" v-model="CaseForm.birthday" style="width: 85%"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-row>
          <el-col :span="11">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="CaseForm.sex" style="width: 100%">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>

          </el-col>
          <el-col :span="11">
            <el-form-item label="民族" prop="nation">
              <el-input v-model="CaseForm.nation" style="width: 100%">
                <template slot="append">族</template>
              </el-input>
            </el-form-item>
          </el-col>


        </el-row>
        <el-form-item label="户籍地址" prop="serviceAddress">
          <el-input @input="getAddress" v-model="CaseForm.address" style="width: 85%"></el-input>
        </el-form-item>

        <el-form-item label="送达地址" prop="serviceAddress">
          <el-input v-model="CaseForm.serviceAddress" style="width: 85%"></el-input>
        </el-form-item>

        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="CaseForm.phone" style="width: 85%"></el-input>
        </el-form-item>
        <el-form-item label="案件卷宗" prop="fileList">
          <el-upload style="width: 85%" ref="upload" class="upload-demo" :on-remove="fileRemove" :on-change="fileChange"
            :action="getUploadUrl()" :http-request="HttpUploadFile" multiple :auto-upload="false"
            :file-list="CaseForm.fileList" :limit="100">
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
          </el-upload>
        </el-form-item>


        <div class="center">
          <el-button class="" v-permission:function="['liveCase_add_determine']" :disabled="btFlag" type="primary"
            @click="addCase">立即创建</el-button>
          <el-button @click="resetForm('CaseForm')">重置</el-button>
          <el-button @click="cancelAddCase">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="提交法院日期" :close-on-click-modal="false" :visible.sync="entryCourtDataShow" width="30%" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="courtDateForm" :model="courtDateModel" label-width="120" style="width: 100%"
            :rules="courtDateRule">
            <el-form-item label="提交法院日期:" prop="courtDate">
              <el-date-picker v-model="courtDateModel.courtDate" type="date" style="width: 70%"
                value-format="yyyy-MM-dd" placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="entryCourtDataShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" v-permission:function="['liveCase_submitJudge_determine']"
          @click="submitJudge">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 提交立案 -->
    <el-dialog :close-on-click-modal="false" title="立案数据" :visible.sync="entryRegisterShow" width="40%" center>
      <el-row style="width: 100%">
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="year" :model="registerModel" label-width="120" :rules="registerRule">
            <el-form-item label="案号:" prop="year">
              <el-select v-model="registerModel.year" placeholder="" style="width: 60%">
                <el-option label="2023" value="2023"></el-option>
                <el-option label="2024" value="2024"></el-option>
                <el-option label="2025" value="2025"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="5" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 7 }">
          <el-form ref="code" label-width="120" :model="registerModel" style="width: 100%" :rules="registerRule">
            <el-form-item label="粤" prop="code">
              <el-select v-model="registerModel.code" placeholder="" style="width: 70%">
                <el-option label="0902" value="0902"></el-option>
                <el-option label="0904" value="0904"></el-option>
                <el-option label="0981" value="0981"></el-option>
                <el-option label="0982" value="0982"></el-option>
                <el-option label="0983" value="0983"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="registerCode" label-width="120" :model="registerModel" style="width: 100%"
            :rules="registerRule">
            <el-form-item label="民初" prop="registerCode">
              <el-input style="width: 60%" placeholder="" v-model="registerModel.registerCode"
                class="input-with-select">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1" style="line-height: 40px"> 号 </el-col>
      </el-row>

      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="registerContent" :model="registerModel" label-width="120" :inline="true" style="width: 100%"
            :rules="registerRule">

            <el-form-item label="案件立案日期:" prop="filingDate">
              <el-date-picker style="width: 250px" v-model="registerModel.filingDate" type="date"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="缴费短信内容:" prop="message">
              <el-input placeholder="" style="width: 250px" v-model="registerModel.message" type="textarea"
                :rows="10" />

            </el-form-item>

          </el-form>
        </el-col>
      </el-row>

      <span style="width: 10rem" slot="footer" class="dialog-footer">
        <el-button @click="registerBoxShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" v-permission:function="['liveCase_register_determine']"
          @click="addRegister()">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 上传缴费凭证 -->
    <el-dialog title="上传缴费凭证" :close-on-click-modal="false" :visible.sync="uploadVoucherShow" width="30%" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="vocherForm" :model="payModel" :rules="VocherRules" label-width="" style="width: 100%">
            <el-form-item label="缴费日期:" prop="payDate">
              <el-date-picker style="width: 12rem" v-model="payModel.payDate" type="date" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="缴费凭证">
              <el-upload style="width: 12rem" ref="upload" class="upload-demo" :on-change="fileChange"
                :action="getUploadUrl()" :http-request="HttpUploadFile" multiple :auto-upload="false"
                :file-list="fileList" :limit="100">
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
              </el-upload>
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadVoucherShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="uploadVocher"
          v-permission:function="['liveCase_pay_determine']">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 案件异动 -->
    <el-dialog title="案件异动" :close-on-click-modal="false" :visible.sync="abnormalShow" width="30%" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">

          <el-form ref="abnormal" :rules="abnormalRules" :model="abnormal" label-width="" style="width: 100%">
            <el-form-item label="文书材料">
              <el-upload style="width: 17rem" ref="upload" class="upload-demo" :on-remove="abnormalRemove"
                :on-change="abnormalChange" :action="getUploadUrl()" :http-request="HttpUploadFile" multiple
                :auto-upload="false" :file-list="abnormal.fileList" :limit="100">
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
              </el-upload>
            </el-form-item>
            <el-form-item label="异动原因:" prop="reason">
              <el-input placeholder="" style="width: 17rem" v-model="abnormal.reason" type="textarea" :rows="6" />

            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="abnormalShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" v-permission:function="['liveCase_abnormal_determine']"
          @click="addAbnormal()">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 录入开庭信息 -->
    <el-dialog title="开庭时间" :visible.sync="hearingShow" width="30%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="hearingTimeModel" :model="hearingTimeModel" label-width="120" :rules="hearingTimeRule">
            <el-form-item label="开庭时间:" prop="hearingDate">
              <el-date-picker v-model="hearingTimeModel.hearingDate" type="datetime" style="width: 12rem"
                placeholder="请选择开庭日期" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="审判法官:" prop="judge">
              <el-input v-model="hearingTimeModel.judge" style="width: 12rem" placeholder="请输入审判法官">
              </el-input>
            </el-form-item>
            <el-form-item label="开庭文书" prop="fileList">
              <el-upload style="width: 12rem" ref="upload" class="upload-demo" :on-remove="hearingRemove"
                :on-change="hearingChange" :action="getHearingUrl()" :http-request="mutUploadFile" multiple
                :auto-upload="false" :file-list="hearingTimeModel.fileList" :limit="100">
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="hearingShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="hearing()"
          v-permission:function="['liveCase_scheduling_determine']">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 录入判决信息 -->
    <el-dialog title="判决信息" :visible.sync="judgementEndShow" width="30%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="judgementModel" :model="judgementModel" label-width="120" :rules="judgementRules">
            <el-form-item label="判决日期:" prop="judegmentDate">
              <el-date-picker v-model="judgementModel.judegmentDate" type="date" style="width: 12rem"
                placeholder="请选择判决日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="判决文书" prop="fileList">
              <el-upload style="width: 12rem" ref="upload" class="upload-demo" :on-remove="judgementRemove"
                :on-change="judgementChange" :action="getJudgement()" :http-request="HttpUploadFile" multiple
                :auto-upload="false" :file-list="judgementModel.fileList" :limit="100">
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="judgementEndShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="judgementEnd"
          v-permission:function="['liveCase_judgement_determine']">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>
<style scoped>
@import "../../../assets/style/LiveCaseInfo/index.css";
</style>
<script>
import Vue from "vue";
import {
  getList,
  addCase,
  identifyIdCard,
  startDisposal,
  submitCourt,
  registered,
  pay,
  caseAbnormal,
  scheduling,
  judgementEnd,
  judgement,
  getFileList,
  deleteCaseUploadFile,
  upLoadCaseFile,
  deleteCase,
  batchRemark
} from "@/api/czManager/liveCaseInfo/index";
import { downLoadFile } from '@/plugin/axios'
import store from "@/store";
import Register from "@/pages/caseMediate/liveCaseEdit";
import Preview from "@/pages/caseMediate/liveCasePreview";
import { uploadFile } from '@/plugin/axios'
import util from "@/libs/util";
import {

  setAgent,
  deletetCase,
  batchDeletetCase,
  setCaseStatus,
  switchRegister,
  confirmPayment,
  setTrialDate,
  performance,
  noPerformance,
  confirmDiaoDang,
  enterVerdict,
  getCaseUploadFile,
} from "@/api/czManager/czCaseInfo/index";
import { getCastAllInfo } from "@/api/czManager/register/index";
import {  addObj, putObj } from "@/api/czManager/executePlan/index";
import { mapGetters } from "vuex";
import { getUserId } from "@/api/sys/user.js";

import { validatePhone, validateCardId } from "@/utils/myUtils/validate";
var validateId = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("身份证不能为空"));
  } else if (!validateCardId(value)) {
    callback("身份证格式不对");
  } else {
    callback();
  }
};

var validatePh = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else if (!validatePhone(value)) {
    callback("手机号格式不对");
  } else {
    callback();
  }
};


export default {
  name: "userManager",
  components: {
    Register,
    Preview,
  },
  data() {
    return {
      showNotes: false,
      remark: "",
      caseFile: [],
      caseFileShow: false,
      caseUploadShow: false,
      caseUploadData: {},
      tableHeight: '510',
      idCardFileList: [],
      total: 0,
      payModel: {
        fileList: [],
        payDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      },
      // newCaseObj:
      VocherRules: {
        fileList: [{
          required: true, message: '请选择文书', trigger: 'change'
        }],
        payDate: [
          {
            required: true, message: '请选择缴费日期', trigger: 'change'
          }
        ]
      },
      fileData: new FormData(),
      judgementModel: {
        fileList: []
      },
      judgementEndShow: false,
      judgementRules: {
        judegmentDate: [{
          required: true, message: "请选择日期", trigger: "change"
        }],
        fileList: [{
          required: true, message: '请选择文书料', trigger: 'change'
        }]
      },
      hearingTimeRule: {
        judge: [{ required: true, message: "请输入法官", trigger: "blur" }],
        hearingDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        fileList: [{
          required: true, message: '请选择文书', trigger: 'change'
        }]
      },
      hearingShow: false,
      abnormalShow: false,
      abnormal: {
        reason: '',
        fileList: []
      },
      uploadVoucherShow: false,
      abnormalRules: {
        reason: [{
          required: true, message: '请输异动原因', trigger: 'blur'
        }],
        fileList: [
          {
            required: true, message: '请选择文书', trigger: 'change'
          }
        ]
      },
      registerRule: {
        year: [{
          required: true, message: '请选择年份', trigger: 'change'
        }],
        code: [
          {
            required: true, message: '请选择编号', trigger: 'change'
          }
        ],
        registerCode: [{
          required: true, message: '请输入案号', trigger: 'blur'
        }],
        message: [{
          required: true, message: '请输入短信内容', trigger: 'blur'
        }],
        filingDate: [{
          required: true, message: '请选择立案日期', trigger: 'change'
        }]
      },
      caseData: {
        message: '',
        filingDate: ''
      },
      entryRegisterShow: false,
      btFlag: false,
      courtDateRule: {
        courtDate: [{
          required: true, message: '请输入提交法院日期', trigger: 'change'
        }]
      },
      courtDateModel: {
        courtDate: '',
      },
      entryCourtDataShow: false,
      fileList: [],

      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, validator: validatePh }],
        serviceAddress: [{ required: true, message: "请输入户籍地址", trigger: "blur" }],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" },],
        sex: [{ required: true, message: "请选择性别", trigger: "change" },],
        idCard: [{ required: true, validator: validateId },],
        fileList: [{ required: true, message: "请选择案件卷宗", trigger: 'change' }],
      },
      plaintiffName: [],
      centerDialogVisible: false,
      setStatusdialogVisible: false,
      caseFileShow: false,
      total: 0,
      tabIndex: 'caseInfo',
      isPreview: false,
      testVis: false,
      list: [],
      isAdmin: "",
      options: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      plStatus: { caseSt: "", date: "" },
      registerModel: { year: "2024", code: "0902", registerCode: "" },

      caseData: {
        caseId: "",
        paymentDate: "",
        registerCode: "",
        filingDate: "",
      },
      hearingTimeModel: { hearingDate: "", judge: "", fileList: [] },
      isShowList: [],
      headrt: 240,
      CaseInfo: {
        keyWord: '',
        page: 1,
        limit: 50,
      },
      CaseForm: { name: "", nation: "", serviceAddress: "", phone: "", fileList: [], sex: '', idCard: '', birthday: '' },
      listLoading: true,
      validFile: false,
      //列表多选框数组
      caseIdList: [],
    };
  },
  watch: {

  },
  created() {


    let h = localStorage.getItem("liveTableHeight");
    if (h != undefined && h != "" && h != null) {
      this.tableHeight = h;
    }
    this.isAdmin =
      this.$store.state.d2admin.permission.userName == "蓬莱管理员";
    this.getList();
    getUserId()
      .then((res) => {
        this.userId = res.id;
        let timeout = setInterval(() => {
          this.wst.send("-2");
          this.headrt--;
          if (this.headrt == 0) {
            this.wst.close();
            clearInterval(timeout);
          }
        }, 59000);
      })
      .catch((error) => { });
    store.dispatch("d2admin/data/getSelectList").then((res) => {
      this.courtName = store.state.d2admin.data.courtList;
      this.caseStatus = store.state.d2admin.data.caseStatus;
    });



  },
  computed: {
    ...mapGetters(["elements"]),
  },
  methods: {
    batchRemark() {
      if (this.caseIdList.length < 1) { this.$message.error("请勾选至少一个案件"); return; }
      batchRemark({ caseIdList: this.caseIdList, remark: this.remark })
        .then(res => {
          if (res.statusCode == 2000) {
            this.$message.success("成功");
            this.getList()
            this.remark = ''
            this.showNotes = false
          }
        })
    },
    delete(id) {

      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        deleteCase(id).then(res => {
          if (res.statusCode == 2000) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      });

    },
    getCaseUploadUrl() {
      return (
        process.env.VUE_APP_API + "/api/case/liveCaseFiles/upload"
      );
    },
    downCaseUploadFile(id) {
      downLoadFile(this, { method: 'get', url: '/api/case/liveCaseFiles/download/' + id, isValidate: true, fileNum: 0 },
        (req) => { return req })
      return
    },
    deleteCaseUploadFile(id) {
      this.$confirm("是否删除?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", }).then((res) => {
        deleteCaseUploadFile(id).then((res) => {

          if (res.statusCode == 2000) {
            this.$message({ message: "删除成功", type: "success", });
            this.getFileList()

          }
          this.getList()
        });
      });
    },
    setTableHeight(val) {
      localStorage.setItem("liveTableHeight", val);
      this.tableHeight = val;
    },
    getAddress(e) {
      this.CaseForm.serviceAddress = e
    },
    cancelAddCase() {
      this.centerDialogVisible = false
      this.idCardFileList = []
      for (let key in this.CaseForm) {
        this.CaseForm[key] = ''
      }
    },
    getBirthdayAndSex(val) {
      if (val.length >= 14) {
        let temp = val.substring(6, 10);
        temp += "-" + val.substring(10, 12);
        temp += "-" + val.substring(12, 14);
        // this.birthday = temp;
        this.CaseForm.birthday = temp;
      }
      if (val.length >= 17) {
        this.CaseForm.sex = val.substring(16, 17) % 2 == 1 ? "男" : "女";
        // this.CaseForm.sex = this.sex;
      }
    },
    getList() {
      this.listLoading = true;
      getList(this.CaseInfo).then(res => {
        this.list = res.records
        this.total = res.total
        this.listLoading = false
        for (let i = 0; i < this.list.length; i++) {
          this.isShowList[i] = this.list[i].caseStatus == "未处置" || this.list[i].caseStatus == "处置中" || this.list[i].caseStatus == "提交诉讼服务网";
        }
      })
    },
    resetFileList() {
      this.fileList = [];
      this.CaseForm.fileList = []
      this.courtDateModel.fileList = []
      this.abnormal.fileList = []
      this.hearingTimeModel.fileList = []
      this.judgementModel.fileList = []
      this.payModel.fileList = []
      this.fileData = new FormData()
    },
    addCase() {
      this.$refs["CaseForm"].validate((valid) => {
        if (valid) {
          uploadFile(this, this.CaseForm, { url: '/api/case/liveCaseInfo/caseBaseInfo' }, (res) => {
            this.idCardFileList = []
            this.centerDialogVisible = false
          }, this.$refs.upload)

          return
          let loading = this.$loading({
            lock: true,
            text: "上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.btFlag = true
          const token = util.cookies.get("token");
          this.$refs.upload.submit();
          this.fileData.append("sex", this.CaseForm.sex);
          this.fileData.append("nation", this.CaseForm.nation);
          this.fileData.append("name", this.CaseForm.name);
          this.fileData.append("serviceAddress", this.CaseForm.serviceAddress);
          this.fileData.append("phone", this.CaseForm.phone);
          this.fileData.append("idCard", this.CaseForm.idCard);
          this.fileData.append('birthday', this.CaseForm.birthday)
          this.fileData.append('address', this.CaseForm.address)

          addCase(this.fileData).then(res => {
            this.fileData = new FormData()
            loading.close()
            // loading.close();
            this.btFlag = false
            for (let key in this.CaseForm) {
              if (key != 'fileList') {
                this.CaseForm[key] = ''
              } else if (key == 'fileList') {
                this.CaseForm[key] = []
              }
            }
            this.idCardFileList = []
            this.$message.success('成功')
            this.centerDialogVisible = false
            this.getList()
          })
        }
      });
    },
    uploadVocher() {
      this.$refs["vocherForm"].validate((valid) => {
        if (valid) {
          this.fileData.append('caseId', this.id)
          this.fileData.append('payCompletionDate', this.payModel.payDate)
          uploadFile(this, {}, { url: '/api/case/liveCaseInfo/yiJiaoFei' }, (res) => {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            this.payModel.payDate = year + '-' + month + '-' + day
            this.uploadVoucherShow = false
          }, this.$refs.upload)
          return
          let loading = this.$loading({
            lock: true,
            text: "上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.btFlag = true
          this.$refs.upload.submit();
          this.fileData.append('caseId', this.id)
          this.fileData.append('payCompletionDate', this.payModel.payDate)
          pay(this.fileData).then(res => {
            loading.close()
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            this.payModel.payDate = year + '-' + month + '-' + day
            this.btFlag = false
            this.fileData = new FormData();
            if (res.data.statusCode == 2000) {
              this.$message.success('成功')
              // this.fileList = []
              this.uploadVoucherShow = false
              this.getList()
            }
          })
        }
      });
    },
    judgementEnd() {
      this.$refs["judgementModel"].validate((valid) => {
        if (valid) {
          this.fileData.append("decisionDate", this.judgementModel.judegmentDate)
          this.fileData.append('caseId', this.id)
          uploadFile(this, {}, { url: '/api/case/liveCaseInfo/yiPanJue' }, (res) => {
            this.judgementEndShow = false
            this.judgementModel = {}
          }, this.$refs.upload)
          return
          let loading = this.$loading({
            lock: true,
            text: "上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$refs.upload.submit();

          judgementEnd(this.fileData).then(res => {
            loading.close()
            this.fileData = new FormData();
            if (res.data.statusCode == 2000) {
              this.$message.success('已判决')
              this.judgementEndShow = false
              this.judgementModel = {}
              this.getList()
            }
          })
        }
      });
    },
    addAbnormal() {
      this.$refs["abnormal"].validate((valid) => {
        if (valid) {
          this.fileData.append('reason', this.abnormal.reason)
          this.fileData.append('caseId', this.id)
          uploadFile(this, {}, { url: '/api/case/liveCaseInfo/caseYiDong' }, (res) => {
            this.abnormal.reason = ''
            this.abnormal.fileList = []
            this.abnormalShow = false
          }, this.$refs.upload)
          return
          this.$refs.upload.submit();

          caseAbnormal(this.fileData).then(res => {
            this.fileData = new FormData();
            loading.close()
            this.abnormal.reason = ''
            this.abnormal.fileList = []
            if (res.data.statusCode == 2000) {
              this.abnormalShow = false
              this.$message.success('案件异动')
              this.getList()
            }
          })
        }
      });
    },
    addRegister() {
      let yearFlag = false;
      let codeFlag = false;
      let contentFlag = false;
      let registerCodeFlag = false
      let registerCode = ''
      // this.$refs["paymentDate"].validate((valid) => { if (valid) { dateFlag = true; } });
      this.$refs["code"].validate((valid) => { if (valid) { codeFlag = true; } });
      this.$refs["registerCode"].validate((valid) => { if (valid) { registerCodeFlag = true; } });
      this.$refs["year"].validate((valid) => { if (valid) { yearFlag = true; } });
      this.$refs["registerContent"].validate((valid) => { if (valid) contentFlag = true })
      if (yearFlag == true && codeFlag == true && registerCodeFlag == true && contentFlag == true) {
        this.btFlag = true;
        registerCode = `（${this.registerModel.year}）` + "粤" + this.registerModel.code + "民初" + this.registerModel.registerCode + "号";

      }
      let req = { caseId: this.id, registerCode: registerCode, paymentMessage: this.registerModel.message, filingDate: this.registerModel.filingDate }
      registered(req).then(res => {
        if (res.statusCode == 2000) {
          this.$message.success('已立案')
          this.getList()
          this.entryRegisterShow = false
          this.registerModel.code = ''
          this.registerModel.message = ''
          this.registerModel.filingDate = ''
          this.registerModel.registerCode = ''
        }
        this.btFlag = false

      })

    },
    submitJudge() {
      this.$refs["courtDateForm"].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          submitCourt({
            caseId: this.id,
            courtSubDate: this.courtDateModel.courtDate
          }).then((res) => {
            this.btFlag = false;
            if (res.statusCode == 2000) {
              this.$message({ message: "成功", type: "success" });
              this.entryCourtDataShow = false;
              this.getList();
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {

          });
        } else {

        }
      });
    },
    ocrIdCard(obj) {

      this.CaseForm.birthday = obj.birthday.length == 8 ? obj.birthday.substring(0, 4) + '-'
        + obj.birthday.substring(4, 6) + '-' + obj.birthday.substring(6, 8) : ''
      this.CaseForm.serviceAddress = obj.address ? obj.address : this.CaseForm.serviceAddress
      this.CaseForm.nation = obj.nation ? obj.nation : this.CaseForm.nation
      this.CaseForm.idCard = obj.idCard ? obj.idCard : this.CaseForm.idCard
      this.CaseForm.name = obj.name ? obj.name : this.CaseForm.name

      this.CaseForm.address = obj.address ? obj.address : this.CaseForm.address
      this.CaseForm.sex = obj.idCard.substring(16, 17) % 2 == 0 ? '女' : '男'
      Object.assign(this.CaseForm, this.CaseForm)
      this.idCardFileList = []
    },
    ocrUploadFile(val) {
      // this.isLoad = true;
      this.fileData.append("file", val.file);
      const token = util.cookies.get("token");
      identifyIdCard(this.fileData, token).then((res) => {
        if (
          res.data.data == "" ||
          res.data.data == undefined ||
          res.data.data == null
        ) {
          this.$message.error("识别失败");
          return;
        }
        this.fileData = new FormData();
        this.$message.success("识别成功");
        this.ocrIdCard(res.data.data)
        // let card = ocrCard(res.data.data);
        // Object.assign(this.caseInfo.cardInfoList[this.carIndex], card);
      }).catch(err => {
        this.fileData = new FormData();
      });
      // this.isLoad = false;
    },
    HttpUploadFile(val) {
      this.fileData.append("file", val.file);
    },
    mutUploadFile(val) {
      this.fileData.append('fileList', val.file)
    },
    mutUploadFile1(val) {
      this.fileData.append('fields', val.file)
    },
    getIdCardUploadUrl() {
      return process.env.VUE_APP_API + "/api/case/liveCaseInfo/ocrIdCard";
    },
    getUploadUrl() {
      return process.env.VUE_APP_API + "/api/case/liveCaseInfo/caseBaseInfo";
    },
    getJudgement() {
      return process.env.VUE_APP_API + "/api/case/liveCaseInfo/yiPanJue";
    },
    getHearingUrl() {
      return process.env.VUE_APP_API + "/api/case/liveCaseInfo/yiPaiQ";
    },
    ocrFileChange(file, fileList) {
      this.idCardFileList = fileList
    },
    // 由于上传文件复用了该方法，所以，每个上传文件时都要给每个上传文件的所属对象添加，确保上传文件校验成功
    fileChange(file, fileList) {
      this.fileList = fileList;
      this.CaseForm.fileList = fileList
      if (fileList.length !== 0) {
        this.$refs.CaseForm.clearValidate('fileList')

      }
      // this.courtDateModel.fileList = fileList
      // this.abnormal.fileList = fileList
      // this.hearingTimeModel.fileList = fileList
      // this.judgementModel.fileList = fileList
      // this.payModel.fileList = fileList
      this.fileData.append("file", file); // append增加数据
    },
    hearingChange(file, fileList) {
      this.fileList = fileList;
      this.hearingTimeModel.fileList = fileList
      if (fileList.length !== 0) {
        this.$refs.hearingTimeModel.clearValidate('fileList')
      }
    },
    judgementChange(file, fileList) {
      this.fileList = fileList;
      this.judgementModel.fileList = fileList
      if (fileList.length !== 0) {
        this.$refs.judgementModel.clearValidate('fileList')
      }
    },
    abnormalChange(file, fileList) {
      // this.fileList = fileList;
      this.abnormal.fileList = fileList
      if (fileList.length !== 0) {
        this.$refs.abnormal.clearValidate('fileList')
      }
    },
    judgementRemove(uploadFile, fileList) {
      this.judgementModel.fileList
      if (fileList.length === 0) {
        this.$refs.judgementModel.validateField('fileList')
      }
    },
    hearingRemove(uploadFile, fileList) {
      this.hearingTimeModel.fileList = fileList
      if (fileList.length === 0) {
        this.$refs.hearingTimeModel.validateField('fileList')
      }
    },
    abnormalRemove(uploadFile, fileList) {
      this.abnormal.fileList = fileList
      if (fileList.length === 0) {
        this.$refs.abnormal.validateField('fileList')
      }
    },
    fileRemove(uploadFile, fileList) {
      this.CaseForm.fileList = fileList
      if (fileList.length === 0) {
        this.$refs.CaseForm.validateField('fileList')
      }
    },

    showCreateCase() {
      this.resetFileList()
      this.centerDialogVisible = true
      // this.CaseForm = {};

    },
    getCaseStatus(val) {
      this.getList();
    },
    getNumber(value, object, filed) {
      let val = "" + value;
      val = val.replace(/[^\d^\.]+/g, "").replace(/^0+(\d)/, "$1").match(/^\d*(\.?\d{0,2})/g)[0] || "";
      object[filed] = val;
    },





    getObj(caseStatus, caseId, index) {
      if (caseStatus == "执行中") {
        this.edit[index] = true;
      }
    },
    addObj() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          addObj(this.exeForm).then((res) => {
            if (res.statusCode == 2000) {
              this.$message({ message: "录入成功", type: "success" });
              this.exeFormVisible = false;
              this.getList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
                duration: 5000,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    putObj() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          putObj(this.exeForm.caseId, this.exeForm).then((res) => {
            if (res.statusCode == 2000) {
              this.$message({ message: "修改成功", type: "success", });
              this.exeFormVisible = false;
              this.getList();
            } else {
              this.$message({ message: res.message, type: "error", duration: 5000, });
            }
          });
        }
      });
    },
    noPerformance(caseId) {
      noPerformance(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "成功", type: "success" });
        }
        this.getList();
      });
    },
    performance(caseId) {
      performance(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "成功", type: "success" });
        }
        this.getList();
      });
    },

    enterVerdict(caseId) {
      enterVerdict(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "确认开庭", type: "success" });
        }
        this.getList();
      });
    },
    confirmDiaoDang(caseId) {
      confirmDiaoDang(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "完成调档", type: "success" });
        }
        this.getList();
      });
    },
    switchRegister(caseId) {
      switchRegister(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "成功", type: "success" });
        }
        this.getList();
      });
    },
    getPreviewData() {
      this.tabIndex = "caseInfo";
      getCastAllInfo({ caseId: this.id }).then((res) => {
        this.previewData = res;
        this.isPreview = true;
      });
      this.getFileList()
    },
    getFileList() {
      this.caseFile = []
      getFileList(this.id).then(res => {
        if (res && res.length > 0) {
          this.caseFile = res
          this.caseFileShow = true
        }

      })
    },
    showPreview(id) {
      this.id = id;
      this.getPreviewData();
    },
    handleCheckAllChange(val) {
      if (val == true) this.checkedDocument = this.documentType;
      else {
        this.checkedDocument = [];
      }
      this.isIndeterminate = false;
    },
    handleCheckedDocumentChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.documentType.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.documentType.length;
    },
    backToStart(id) {
      backToStart(id).then((res) => {
        this.getList();
        this.$message({ message: res.message, type: "success", });
      });
    },
    setEditCaseInfo() {
      if (this.editCase == undefined) {
        if (this.editCase.length == 0)
          for (let i = 0; i < this.list.length; i++) {
            Vue.set(this.list[i], "username", undefined);
            Vue.set(this.list[i], "show", false);
          }
      }
      for (let i = 0; i < this.list.length; i++) {
        for (let j = 0; j < this.editCase.length; j++) {
          if (this.list[i].id == this.editCase[j].caseId) {
            if (this.id != this.editCase[j].caseId) {
              Vue.set(this.list[i], "username", this.editCase[j].username + "正在编辑");
            }
            this.list[i].show = true;
            break;
          } else {
            Vue.set(this.list[i], "username", undefined);
            Vue.set(this.list[i], "show", false);
          }
        }
      }
    },
    onMessage(res) {
      var json = eval("(" + res.data + ")");
      this.editCase = json.data;
      if (json.status == 200) {
        this.editCase = json.data;
      } else if (json.status == 201) {
        this.testVis = true;
        this.editCase = json.data;
      } else if (json.status == 202) {
        this.editCase = json.data;
        this.setEditCaseInfo();
      } else if (json.status == 203) {
        this.editCase = json.data;
        this.setEditCaseInfo();
      } else if (json.status == 400) {
        this.editCase = json.data;
        this.$notify({ title: "提示", message: "案件正在被编辑" });
      }
      let t = setInterval(() => {
        if (this.list != undefined && this.list != null) {
          this.setEditCaseInfo();
          clearInterval(t);
        }
      }, 1000);

      if (json.status == 201) {
        for (let i = 0; i < this.list.length; i++) {
          this.tempShow.push(this.list[i].show);
          this.list[i].show = false;
        }
      }
    },
    onError() { },
    onOpen() { },
    onclose() {
      this.reLink();
    },
    reLink() {
      let t = setInterval(() => {
        if (this.wst.readyState == 3) {
          clearInterval(t);
        }
      }, 1000);
    },
    reScheduleg(caseId) {
      reScheduleg(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "重新排期", type: "success" });
          this.getList();
        }
      });
    },
    confirmPayment(caseId) {
      this.$confirm("是否确认缴费?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", }).then((res) => {
        confirmPayment(caseId).then((res) => {
          if (res.statusCode == 2000) {
            this.$message({ message: "确认缴费", type: "success" });
            this.getList();
          }
        });
      });
    },
    hearing() {
      this.$refs.hearingTimeModel.validate((valid) => {
        if (valid) {
          this.fileData.append('caseId', this.id)
          this.fileData.append('trialDate', this.hearingTimeModel.hearingDate)
          this.fileData.append('undertakeJudge', this.hearingTimeModel.judge)


          uploadFile(this, {}, { url: '/api/case/liveCaseInfo/yiPaiQi' }
            , (res) => {
              this.hearingTimeModel = {};
              this.hearingShow = false;
            }, this.$refs.upload);
          return
          this.$refs.upload.submit();
          this.btFlag = true;
          let loading = this.$loading({
            lock: true,
            text: "上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })
          scheduling(this.fileData).then((res) => {
            this.btFlag = false;
            this.fileData = new FormData();
            loading.close()
            if (res.data.statusCode == 2000) {
              this.hearingTimeModel = {}
              this.$message({ message: "设置成功", type: "success" });
              this.getList();
              this.hearingShow = false;
            }

          });
        } else {
          return false;
        }
      });
    },

    closeDia() {
      this.wst.send("0");
      this.headrt = 240;
    },
    getObjToForm(caseId) {
      getObj(caseId).then((res) => { });
    },
    handleCommand(command) {
      this.resetFileList()
      this.id = command.row.id;
      switch (command.command) {
        case 'delete':
          this.delete(command.row.id)
          break;
        case "upload":
          this.caseUploadShow = true;
          break;
        case 'startDisposal':
          startDisposal(command.row.id).then(res => {
            if (res.statusCode == 2000) {
              this.$message.success('开始处置')
              this.getList()
            }
          })
          break;
        case "edit":
          this.testVis = true;

          // this.wst.send(this.id);
          this.headrt = 240;
          break;
        case "submitJudge":
          this.entryCourtDataShow = true
          break;
        case "registered":
          this.entryRegisterShow = true
          break;
        case "pay":
          this.uploadVoucherShow = true
          break;
        case 'scheduling':
          this.hearingShow = true
          break;
        case 'judgement':

          judgement(this.id).then(res => {
            if (res.statusCode == 2000) {
              this.$message.success('已开庭')
              this.getList()
            }
          })
          break;
        case 'reScheduling':
          this.hearingTimeModel.fileList = []
          this.hearingShow = true
          break;
        case 'caseAbnormal':
          this.abnormal.fileList = []
          this.abnormalShow = true
          break;
        case 'scheduling':
          this.hearingTimeModel.fileList = []
          this.hearingShow = true
          break;
        case 'judgementEnd':
          this.judgementModel.fileList = []
          this.judgementEndShow = true
          break;
        default:
          break;
      }
    },
    showEditPage(index, row) {
      if (row.caseStatus === "处置中" || row.caseStatus === "未处置") {
        this.testVis = true;
        this.id = row.id;
        this.currentRow = row;
        this.listIndex = index;
        this.currentList = this.list;
        this.headrt = 240;
      } else {
        this.id = row.id;
        this.getPreviewData();
        return;
      }
    },
    /**
     * 删除单个案件
     * @param {} id
     */
    delCase(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        deletetCase(id).then((res) => {
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success",
            duration: 2000,
          });
          this.getList();
        });
      });
    },
    /**
     * 批量删除
     */
    batchDelete() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      var formData = new FormData();
      formData.append("caseIdList", this.caseIdList);
      this.$confirm("确认删除所选案件, 是否继续?", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        batchDeletetCase(formData).then((res) => {
          this.$notify({
            title: "操作结果", message: res.message, type: res.statusCode === 2000 ? "success" : "error", duration: 2000,
          });
          this.getList();
        });
      });
    },
    showDialog(index, row, command) {
      return { index: index, row: row, command: command };
    },
    addCaseFile() {
      this.fileData.append("caseId", this.id);
      uploadFile(this, {}, { url: '/api/case/liveCaseFiles/upload' }, (res) => {
        this.caseUploadShow = false;
      }, this.$refs.caseUpload)
      return
      let loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.addCaseFileShow = false;
      this.$refs.caseUpload.submit();
      this.fileData.append("caseId", this.id);

      upLoadCaseFile(this.fileData).then((res) => {
        loading.close()
        this.fileData = new FormData()
        if (res.statusCode == 2000) {
          this.$message({ duration: 5000, message: "上传成功", type: "success", });
        } else {
          this.$message({ duration: 5000, message: "上传失败", type: "error" });
        }
        this.caseUploadShow = false;
      });
    },

    search() {
      this.CaseInfo.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.CaseInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.CaseInfo.page = val;
      this.getList();
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({ title: "成功", message: "更新成功", type: "success", duration: 2000, });
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 多选框选择方法
     * @param {} val
     */
    handleSelectionChange(val) {
      let arr = [];
      for (let item of val) {
        arr.push(item.id);
      }
      this.caseIdList = arr;
    },
    /**
     * 设置代理人
     */
    setCaseStatus() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      this.$refs.plCaseForm.validate((valid) => {
        if (valid) {
          var formData = new FormData();
          formData.append("status", this.plStatus.caseSt);
          formData.append("caseIdList", this.caseIdList);
          formData.append("date", this.plStatus.date == "" ? "" : this.plStatus.date);
          setCaseStatus(formData).then((res) => {
            this.$notify({ title: res.statusCode == 2000 ? "成功" : "失败", message: res.message, type: res.statusCode == 2000 ? "success" : "error", duration: 2000, });
            this.getList();
            this.setStatusdialogVisible = false;
          });
        }
      });
    },
    setAgent() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      if (this.setAgentId == null && this.setAgentId == undefined) {
        this.$message.error("请选择律师");
        return;
      }
      var formData = new FormData();
      formData.append("agentIdList", this.setAgentId);
      formData.append("caseIdList", this.caseIdList);
      setAgent(formData).then((res) => {
        this.$notify({
          title: "操作结果", message: res.message, type: res.statusCode === 2000 ? "success" : "error", duration: 2000,
        });
      });
      this.setAgentdialogVisible = false;
    },
    resetTemp() {
      this.CaseInfo.keyWord = ''
      this.getList();
    },
  },
};
</script>
<style scoped>
* {}
</style>